const siteMeta = {
  title: 'Kolyde',
  heroTitle: 'The Academic Debate Application Platform ',
  description:
    'Kolyde App is an academic debate platform that will connect people from a variety of professions, ethnicities, political affiliations and social economic backgrounds and provide a platform for healthy dialogue with opponents in a safe bully-free environment where users can have fun and opinions are shared as a non-clandestine forum.',
};

export { siteMeta };
